export default __webpack_public_path__ + "static/media/icon-card-document-configuration.c59892ac.svg";